module.exports = __webpack_public_path__ + "static/media/carclinic_logo.6b9eb9cf.jpg";